import React from 'react';
import TablaEjFiscal from '../components/presupuesto/tablaEfiscal';

function EjeFiscal() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaEjFiscal />
      </div>
  );
}

export default EjeFiscal;




// WEBPACK FOOTER //
// ./src/pages/ejercfiscal.js